<template>
  <VDetailBoxWrapper v-if="showButtonArea">
    <VConfirmation
      v-if="confirmation"
      :id="item.uniqueOrderID"
      v-model="confirmation"
      animation="none"
      class="center"
      heading="order.orderCancelConfirmationHeadline"
      @abort="abortOrderCancel"
      @confirm="executeOrderCancel"
    />
    <VButton
      v-if="showTerminateNonFinalizedOrderButton"
      class="btn-default btn-small button-right"
      label="order.cancelOrderButtonLabel"
      @click.prevent="showConfirmation"
    />
  </VDetailBoxWrapper>
</template>

<script>
import VButton from '@/components/Button';
import VDetailBoxWrapper from '@/components/UI/DetailBox/Wrapper';
import VConfirmation from '@/components/Confirmation';
import Proxy from '@/proxies/SubstoreOrderOverviewProxy';
import { mapGetters } from 'vuex';

export default {
  name: 'OrderOverviewButtons',

  components: {
    VButton,
    VDetailBoxWrapper,
    VConfirmation,
  },

  props: {
    item: {
      type: Object,
      required: true,
    },
  },

  data() {
    return {
      confirmation: null,
    };
  },

  computed: {
    ...mapGetters('system', ['hasFunctionTerminateNonFinalizedOrder']),

    showButtonArea() {
      return this.hasFunctionTerminateNonFinalizedOrder;
    },

    showTerminateNonFinalizedOrderButton() {
      return !this.confirmation && this.hasFunctionTerminateNonFinalizedOrder && !['COMPLETED', 'NOT_COMPLETED', 'CANCELED'].includes(this.item.orderStatus);
    },
  },

  methods: {
    showConfirmation() {
      this.confirmation = { id: this.item.uniqueOrderID, message: { type: 'PROMPT', content: 'order.orderCancelConfirmationPrompt' } };
    },

    async executeOrderCancel() {
      try {
        await new Proxy().cancel(this.item.uniqueOrderID);
        this.confirmation.message = { type: 'SUCCESS', content: 'order.orderCancelConfirmationSuccess' };
      } catch (err) {
        this.confirmation.message = { type: 'ERROR', content: 'order.orderCancelConfirmationError' };
      }
    },

    abortOrderCancel() {
      if (this.confirmation.message?.type === 'SUCCESS') {
        // we want to reload the page, if the orderCancel was performed successfully
        this.$router.go(0);
      }
      this.confirmation = null;
    },
  },
};
</script>

<style lang="scss" scoped>
@import '~@scss';

.button-right {
  margin-right: 0;
  margin-left: auto;
}

.center {
  margin-right: auto;
  margin-left: auto;
}
</style>
